export default __webpack_public_path__ + "static/media/10.715cac99.png";